import {selector} from './selector';
import * as events from "./events";
import {initTutorialModal, verififyRegistrationPlate} from "./events";

const PageRegisterTag = (function ($) {

    function checkTerms() {
        $(selector.btn.submit).prop('disabled', !$(selector.checkTerms).is(':checked'));
    }

    function initEvents() {
        events.initTutorialModal();
        $(document).on('click', selector.reloadCaptcha, events.reloadCaptcha);
        $(document).on('keyup', selector.registrationPlate, events.verififyRegistrationPlate);
        $(document).on('change', selector.form.customerType, events.toggleCustomerType);
    }

    function initialize() {
        initEvents();
        setInterval(checkTerms, 500);
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageRegisterTag};